import { QueryClient } from "@tanstack/react-query";

/**
 * An auth failure is resolved by the axios interceptor (refresh, then redirect
 * to login) on the very first response — a retry can only produce the same
 * status. Retrying one anyway holds the query in its loading state for the
 * whole exponential backoff (1s + 2s + 4s by default) before the redirect the
 * interceptor already decided on becomes visible.
 *
 * Every other error keeps the library's default of three retries.
 */
const isAuthError = (error: unknown) => {
  const status = (error as { response?: { status?: number } })?.response?.status;
  return status === 401 || status === 403;
};

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => !isAuthError(error) && failureCount < 3,
    },
  },
});
